import * as types from "../../constants";
import { deleteAllPatientsFromInvestigation, getAllPatientsInvestigation, saveListPatients, savePatient } from "../../db";
import {
    fetchInvestigations as fetchInvestigationsService
} from "../../services";
import { createUpdateBillingInfoService, getBillablesByCoverageService, getBillablesService, updateBillablesService } from "../../services/billing";
import { decryptSinglePatientData, getLastSyncEventId } from "../../utils";
import { fetchPatientsAction, incrementalSyncPatientsAction, fetchCrossInvestigationPatientsAction } from "./patientsActions";
import { GROUPED_INVESTIGATION_UUID, canUseGroupedView } from "../../constants/grouped";
import { isCorrectionOnlySession } from "../../pages/hospital/MyCorrections/correctionAccess";

export function fetchInvestigations() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });

    return fetchInvestigationsService()
      .then(async (response) => {
        
        dispatch({
            type: types.FETCH_INVESTIGATIONS_SUCCESS,
            investigations: response.investigations,
        });

        const pendingApprovalInvestigation = response.investigations.find((investigation) => investigation.shareStatus === 0);

        if(!pendingApprovalInvestigation){
            const storedInvestigation = localStorage.getItem("uuidInvestigation");
            if(storedInvestigation === GROUPED_INVESTIGATION_UUID){
                // Restore the grouped view only if the researcher still holds the permission.
                if(canUseGroupedView(response.investigations)){
                    dispatch(selectInvestigation(GROUPED_INVESTIGATION_UUID));
                }
                else{
                    localStorage.removeItem("uuidInvestigation");
                }
            }
            else if(response.investigations.length === 1){
                dispatch(selectInvestigation(response.investigations[0].uuid));
            }
            else if(storedInvestigation){
                const investigation = response.investigations.find((investigation) => investigation.uuid === storedInvestigation);
                if(investigation){
                    dispatch(selectInvestigation(investigation.uuid));
                }
            }
        }
        
        
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_INVESTIGATIONS_ERROR });
        throw error;
      });
  };
}

export function createUpdateBillingInfoAction(uuidInvestigation, billingInfo) {
    return async (dispatch) => {
      dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });
  
      return createUpdateBillingInfoService(uuidInvestigation, billingInfo)
        .then((response) => {
          dispatch({
            type: types.UPDATE_BILLING_INFO_SUCCESS,
            billingInfo: response.billingInfo,
          });
        })
        .catch((error) => {
          dispatch({ type: types.UPDATE_BILLING_INFO_ERROR });
          throw error;
        });
    };
}

export function updateBillables(uuidInvestigation, idBillingInfo, billables) {
    return async (dispatch) => {
      dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });
  
      return updateBillablesService(uuidInvestigation, idBillingInfo, billables)
        .then((response) => {
          dispatch({
            type: types.UPDATE_BILLABLES_SUCCESS,
            billables: response.billables,
          });
        })
        .catch((error) => {
          dispatch({ type: types.UPDATE_BILLABLES_ERROR });
          throw error;
        });
    };
}

export function getBillablesAction(uuidInvestigation, idBillingInfo, idCoverage){
    return async (dispatch) => {
        dispatch({ type: types.FETCH_BILLING_LOADING });
        return getBillablesByCoverageService(uuidInvestigation, idBillingInfo, idCoverage)
            .then((response) => {
                dispatch({
                    type: types.GET_BILLABLES_SUCCESS,
                    billables: response.billables,
                });
            })
            .catch((error) => {
                dispatch({ type: types.GET_BILLABLES_ERROR });
                throw error;
            });
    };
}
export function selectInvestigation(uuidInvestigation) {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SELECT_INVESTIGATION,
            selectedInvestigation: uuidInvestigation
        });
        if (uuidInvestigation === GROUPED_INVESTIGATION_UUID) {
            // Grouped mode: aggregate patients across investigations instead of the
            // per-investigation snapshot / incremental sync flow.
            dispatch(fetchCrossInvestigationPatientsAction());
            return;
        }
        const currentState = getState().investigations;
        const investigation = currentState.data.find((inv) => inv.uuid === uuidInvestigation);
        if (!investigation) return;
        // SKIN-600: a dermatologist's web session may not read the patient list (403
        // WEB_SESSION_OUT_OF_SCOPE); its patient page reads only what its corrections need.
        if (isCorrectionOnlySession(currentState.data)) return;

        const lastEventId = getLastSyncEventId(uuidInvestigation);
        if (lastEventId != null) {
            const localPatients = await getAllPatientsInvestigation(uuidInvestigation);
            dispatch({ type: types.INITIALIZE_PATIENTS, payload: { uuidInvestigation, patients: localPatients } });
            dispatch(incrementalSyncPatientsAction(uuidInvestigation, true));
        } else {
            dispatch(fetchPatientsAction(investigation.uuid));
        }
    };
}

export function initializeBilling(newState) {
    return async (dispatch) => {
      dispatch({ 
            type: types.INITIALIZE_INVESTIGATIONS,
            newState:newState
      });
    };
}